import { AppDispatch } from '@/store';
import {
  applicationLoading,
  fetchApplicationSuccess,
  fetchApplicationFailure,
  fetchApplicationSectionsSuccess,
  fetchUserApplicationsSuccess,
} from '../slices';
import {
  adaptApplicationResponseToApplication,
  adaptApplicationSectionResponseToSection,
  adaptUserApplicationsResponseToUserApplications,
} from '@/adapters';
import { ApplicationApi } from '@/api';
import { toStoreError } from '@/types/storeError.interface';

export const fetchUserApplications = () => async (dispatch: AppDispatch) => {
  dispatch(applicationLoading());

  try {
    const result = await new ApplicationApi().getUserApplications();

    if (result.success) {
      const applicationForms = result.data?.applicationForms ?? [];
      dispatch(
        fetchUserApplicationsSuccess(
          adaptUserApplicationsResponseToUserApplications(applicationForms),
        ),
      );
    } else {
      dispatch(fetchApplicationFailure(toStoreError(result.error)));
    }
  } catch (e) {
    console.error(e);
    const error = e as Error;
    dispatch(
      fetchApplicationFailure({
        code: 'UNK_001',
        message: error.message,
        category: 'server',
      }),
    );
  }
};

export const fetchApplication =
  (applicationId: number) => async (dispatch: AppDispatch) => {
    dispatch(applicationLoading());

    try {
      const result = await new ApplicationApi().getApplication({
        applicationId,
      });

      if (result.success) {
        dispatch(
          fetchApplicationSuccess(
            adaptApplicationResponseToApplication(result.data),
          ),
        );
        dispatch(
          fetchApplicationSectionsSuccess(
            adaptApplicationSectionResponseToSection(result.data.sections),
          ),
        );
      } else {
        dispatch(fetchApplicationFailure(toStoreError(result.error)));
      }
    } catch (e) {
      console.error(e);
      const error = e as Error;
      dispatch(
        fetchApplicationFailure({
          code: 'UNK_001',
          message: error.message,
          category: 'server',
        }),
      );
    }
  };
